module.exports = __webpack_public_path__ + "assets/img/news (31).b7d704e9.png";